import { MouseEvent, useCallback, useEffect, useRef } from 'react';
import {
  CompPropsWithChildren,
  ContainerProps,
  JSXElementConstructorWithRef,
} from './utils/types';
import { registerContainer } from './utils/refManager';
import { startDnD } from './utils/dndHandler';

export const useSortableContainer = <Props extends Record<string, any>>({
  axis,
  onSortEnd,
  helperContainer,
  isAutoScroll,
  ...compProps
}: CompPropsWithChildren<
  JSXElementConstructorWithRef<Props & ContainerProps>
>) => {
  const ref = useRef<HTMLElement | null>(null);
  const mouseDownHandler = useCallback(
    (event: MouseEvent) => startDnD(event, ref),
    [ref]
  );

  useEffect(
    () =>
      registerContainer(ref, {
        axis,
        onSortEnd,
        helperContainer,
        isAutoScroll,
      }),
    [axis, onSortEnd, helperContainer, isAutoScroll, ref]
  );

  return {
    compProps,
    mouseDownHandler,
    ref,
  };
};
